import { render, staticRenderFns } from "./ContentCheckResult.vue?vue&type=template&id=21c2db73&scoped=true&"
import script from "./ContentCheckResult.vue?vue&type=script&lang=ts&"
export * from "./ContentCheckResult.vue?vue&type=script&lang=ts&"
import style0 from "./ContentCheckResult.vue?vue&type=style&index=0&id=21c2db73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c2db73",
  null
  
)

export default component.exports